var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_18971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5233 18.9148H5",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7435 18.9148H21.1426",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9809 22.2258H8.18359",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5586 22.2258H29.9834",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5588 27.502H35.3164",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5588 32.7784H35.3164V22.2258",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5596 18.9148V36.4529",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18359 36.4529V18.9148",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2098 24.6755H42.666",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2098 30.3288H42.666",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6672 15.4796H33.6294C34.2381 15.4796 34.7316 14.9861 34.7316 14.3774V3.10219C34.7316 2.49351 34.2381 2 33.6294 2H12.9518C12.3429 2 11.8496 2.49351 11.8496 3.10219V7.22327",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2432 18.9148C40.2692 18.9148 39.4795 18.1933 39.4795 17.3035V10.8412H45.9522V17.3035C45.9522 18.1936 45.1625 18.9148 44.1885 18.9148",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9521 15.9949H47.4874C48.0145 15.9949 48.4417 15.6239 48.4417 15.1657V13.0753C48.4417 12.6177 48.0145 12.2465 47.4874 12.2465H45.9521",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0044 22.2969L30.5621 24.3399C30.8708 25.4709 30.0195 26.5856 28.8472 26.5856H11.5838L9.0957 8.60608C8.99445 7.87514 9.5623 7.22327 10.3003 7.22327H18.4648C19.0721 7.22327 19.5861 7.67122 19.6695 8.27259L21.429 20.9875H28.2895C29.091 20.9875 29.7931 21.5237 30.0044 22.2969Z",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.293 31.0425V26.5856",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 26.5856V31.0425",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8589 33.5027C24.8589 32.144 23.7574 31.0427 22.3989 31.0427H18.9561C17.5973 31.0427 16.4961 32.1442 16.4961 33.5027",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1764 36.6827C26.9039 35.9552 26.9039 34.7757 26.1764 34.0482C25.4489 33.3207 24.2694 33.3207 23.5419 34.0482C22.8144 34.7757 22.8144 35.9552 23.5419 36.6827C24.2694 37.4102 25.4489 37.4102 26.1764 36.6827Z",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3089 35.7906C18.5453 34.7893 17.9251 33.7859 16.9238 33.5496C15.9225 33.3133 14.9191 33.9334 14.6828 34.9347C14.4465 35.9361 15.0666 36.9394 16.0679 37.1757C17.0693 37.4121 18.0726 36.7919 18.3089 35.7906Z",
    stroke: "#141414",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_18971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 37,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon1);
export default __webpack_public_path__ + "static/media/benefitIcon1.dfd8936b6d34b2a04fa7001e77d6e27c.svg";
export { ForwardRef as ReactComponent };